import { Divider as AntDivider } from 'antd'
import type { ComponentProps } from 'react'

type AntDividerProps = ComponentProps<typeof AntDivider>

export interface AppDividerProps extends AntDividerProps {}

export const AppDivider = (props: AppDividerProps) => <AntDivider {...props} />
